export const permissionConstants = {
  ACL_PERMISSION_LIST_REQUEST: 'ACL_PERMISSION_LIST_REQUEST',
  ACL_PERMISSION_LIST_SUCCESS: 'ACL_PERMISSION_LIST_SUCCESS',
  ACL_PERMISSION_LIST_FAILURE: 'ACL_PERMISSION_LIST_FAILURE',
  ACL_PERMISSION_LIST_CHANGED: 'ACL_PERMISSION_LIST_CHANGED',
  ACL_PERMISSION_LIST_PAGINATION: 'ACL_PERMISSION_LIST_PAGINATION',

  ACL_PERMISSION_LOAD_REQUEST: 'ACL_PERMISSION_LOAD_REQUEST',
  ACL_PERMISSION_LOAD_SUCCESS: 'ACL_PERMISSION_LOAD_SUCCESS',
  ACL_PERMISSION_LOAD_FAILURE: 'ACL_PERMISSION_LOAD_FAILURE',

  ACL_PERMISSION_SAVE_REQUEST: 'ACL_PERMISSION_SAVE_REQUEST',
  ACL_PERMISSION_SAVE_SUCCESS: 'ACL_PERMISSION_SAVE_SUCCESS',
  ACL_PERMISSION_SAVE_FAILURE: 'ACL_PERMISSION_SAVE_FAILURE',
};
